import { Button } from 'antd'
import React from 'react'
import { useSkipToEditorTarget } from './skipToEditor'
import './skipToCodeEditorLink.scss'

// Renders nothing unless an editable MonacoEditor is mounted; place it first in the page header
const SkipToCodeEditorLink = () => {
    const focusEditor = useSkipToEditorTarget()
    const anchorRef = React.useRef(null)

    // A view swap (submit, resubmit) removes the control that was clicked, and Chrome keeps tabbing from where it
    // stood — past this header. Put the tab sequence back at the top when the editor appears with focus lost
    React.useEffect(() => {
        if (focusEditor && document.activeElement === document.body) anchorRef.current?.focus({ preventScroll: true })
    }, [focusEditor])

    if (!focusEditor) return null
    return (
        <>
            <div ref={anchorRef} tabIndex={-1} className='skip-to-code-editor-anchor' />
            <Button className='skip-to-code-editor-link' data-test='skip-to-code-editor' onClick={focusEditor}>
                Skip to code editor
            </Button>
        </>
    )
}

export default SkipToCodeEditorLink
